// ATTENTION: This set of hardcoded colors is being deprecated and should NOT be used.
// Please ensure your colors come from the App's theme palette, preferably via the Standard Semantic Color Definitions.
export const controlPalette = {
  /**
   * Default color for controls at rest and the ribbon bar
   */
  defaultBackgroundColor: "#F4F4F4", // Closest Match: neutralLighterAlt: '#F3F2F1', // gray20

  hoverBackgroundColor: "#E1DFDD", // gray40 // correct semantic maps to: neutralLighter gray30

  contextualTabHeaderBackgroundColor: "#E1DFDD", // gray40 // correct semantic maps to: neutralLighterAlt gray20

  /**
   * Background color for when a control is toggled on.
   */
  toggledBackgroundColor: "#D2D0CE", // gray50 // correct semantic maps to: neutralLight gray40

  /**
   * Background color for when controls are selected. Ex: options in a comboBox, options in a checklist.
   * This is not the same as a focused/hovered state. A selected option in a comboBox would also change the
   * value in the comboBox's input field. That is not necessarily the case for a hovered option.
   */
  selectedBackgroundColor: "#D2D0CE", // gray50 // correct semantic maps to: neutralLight gray40

  /**
   * "Expanded" is often used in the same context as "selected" in redlines. In our styles, it refers to the
   * state of a control that is responsible for showing/hiding a contextual menu or gallery. It is in the
   * expanded state when the related contextual menu or gallery is visible
   */
  expandedBackgroundColor: "#D2D0CE", // gray50 // correct semantic maps to: neutralLight gray40

  /**
   * Background color of a control being pressed via a mouse down
   */
  pressedBackgroundColor: "#C8C6C4", // gray60 // correct semantic maps to: neutralQuaternaryAlt gray50

  /**
   * The color to use for the border on a control that has focus
   */
  focusedBorderColor: "#797673", // Closest match: neutralSecondary: '#797775', // gray120 // correct semantic maps to: neutralPrimaryAlt: '#605E5C', // gray130

  /**
   * Background color for text on selection.
   * Usually, to be used inside an ::selection rule.
   */
  textSelectedColor: "#737373", // Closest match: neutralSecondary: '#797775', // gray120
  textDisabledColor: "#707070", // Closest match: neutralSecondary: '#797775', // gray120
  textExpandedColor: "#000000",
  textPressedColor: "#000000",

  /**
   * Text color when a control is toggled on, and hovered over.
   */
  textToggledHoverColor: "#000000",
  textHoverColor: "#333333", // Closest match: neutralPrimary: '#323130', // gray160
  textColor: "#333333", // Closest match: neutralPrimary: '#323130', // gray160

  inputFocusBorderColor: "#969696", // Closest match: neutralSecondaryAlt: '#8A8886', // gray110
  inputBorderColor: "#C8C8C8", // Closest match: neutralQuaternary: '#C8C6C4', // gray60

  /**
   * Menu Colors
   */
  menuBackgroundColor: "#FFFFFF",
  menuItemTextColor: "#222222", // Closest match: neutralDark: '#252423', // gray180
};
